module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resource-panel"
  }, [_c('div', {
    staticClass: "resource-list"
  }, [(!_vm.isSurveysEmpty) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/poll.svg")
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('str.Surveys')) + "\n            ")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', {
    staticClass: "resources"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/icons/unchecked.svg")
    }
  }), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('a', {
      key: index,
      staticClass: "survey item",
      on: {
        "click": function($event) {
          _vm.launchSurvey(survey)
        }
      }
    }, [_vm._v(_vm._s(survey.title))])
  }), _vm._v(" "), _c('p', {
    staticClass: "resource-info"
  }, [_vm._v("(" + _vm._s(_vm.$t('str.TakeTheSurvey')) + ")")])], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.showFiles) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    staticClass: "file",
    attrs: {
      "src": require("../assets/icons/attach-file.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.Files')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Files), function(file, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('div', [_c('img', {
      attrs: {
        "src": require("../assets/icons/download-red.svg")
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.openFile(file.label)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(file.label) + "\n                                "), _c('p', {
      staticClass: "resource-info"
    }, [_vm._v("(" + _vm._s(file.size / 1000) + " " + _vm._s(_vm.$t('str.KB')) + ")")])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showLinks) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/link.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.Links')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Links), function(link, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('img', {
      staticClass: "link",
      attrs: {
        "src": require("../assets/icons/link-red.svg")
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "item",
      attrs: {
        "href": link.data,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.recordLead('link', link.label, link.data)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(link.label) + "\n                        ")])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "resource-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/speaker-notes.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('str.SpeakerNotes')))])]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.presentation.props.Resources[_vm.slideNum].Notes), function(note, index) {
    return _c('li', {
      key: index,
      staticClass: "resources"
    }, [_c('div', {
      staticClass: "notes-display"
    }, [_c('a', {
      staticClass: "note-label"
    }, [_vm._v(_vm._s(note.label))]), _vm._v(" "), _c('p', {
      staticClass: "note-content"
    }, [_vm._v(_vm._s(note.data))])])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "resource-panel-close"
  }, [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06259fc3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResourcesTray.vue
// module id = 458
// module chunks = 0